module.exports = __webpack_public_path__ + "img/viktoriahorbachuk.f3a03675.jpg";